import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { SponsorData } from '~admin/model/sponsor-data';
import { mapSponsorDataList } from '~admin/model/sponsor-data.mapper';
import { SponsorResponse } from '~client/model/sponsor-response';
import { NoArgTask, rxTask } from '~common/helper/mobx-tasks';

export type GetSponsorsTask = NoArgTask<SponsorData[]>;

const performGetSponsors = (): Observable<SponsorResponse[]> =>
  apiClient.adminSponsorController.getSponsors$();

export const getSponsorsTaskFactory = (): GetSponsorsTask =>
  rxTask(() => performGetSponsors().pipe(map(mapSponsorDataList)));



// WEBPACK FOOTER //
// ./interactor/sponsor/perform-get-sponsors.ts